import Api from '../Utils/Axios';

export const GetDashboardCounters = async () => {
  const response = await Api.post('admin/dashboard/counters');
  return response.data;
};
